import React from 'react'
// libs
import { Field } from 'redux-form'
import styled from 'styled-components'
// components
import Input, { CustomInputProps } from 'components/FormElements/Input'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import ErrorMessage, { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
// types
import { Validators } from 'utils/validators'
import { WrappedFieldInputProps, WrappedFieldProps } from 'redux-form/lib/Field'

const ReduxInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

interface Props extends Omit<CustomInputProps, 'ref' | 'size' | 'rows' | 'value' | 'defaultValue'> {
  validate?: Validators
  helperText?: string
  normalize?: (value: string, previousValue?: string, allValues?: any, previousAllValues?: any) => any
  handleInputChange?: (
    value: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    input: WrappedFieldInputProps
  ) => void
}

const renderComponent = ({
  meta,
  type,
  input,
  readOnly,
  helperText,
  handleOnBlur,
  handleInputChange,
  ...rest
}: Props & WrappedFieldProps) => {
  const { touched, error } = meta
  const { name, value } = input

  const onChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!readOnly) {
      input.onChange(event)

      if (handleInputChange) {
        handleInputChange(event, input)
      }
    }
  }

  const onBlur = (event: React.MouseEvent) => {
    input.onBlur(event)
    handleOnBlur?.()
  }

  const isError = !!(meta.touched && meta.error)

  return (
    <FormControl margin='none' fullWidth error={touched && !!error}>
      <ReduxInputWrapper>
        <Input
          name={name}
          type={type}
          value={value}
          isError={isError}
          readOnly={readOnly}
          onChange={onChange}
          handleOnBlur={onBlur}
          {...rest}
        />
        {touched && error && (
          <ErrorMessageWrapper isPassword={type === 'password'}>
            <ErrorMessage>{error}</ErrorMessage>
          </ErrorMessageWrapper>
        )}
      </ReduxInputWrapper>
      {!!helperText && !isError && <FormHelperText sx={{ margin: 0 }}>{helperText}</FormHelperText>}
    </FormControl>
  )
}

const ReduxInput: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxInput
